import React, { FC } from 'react';

import LegalPage from '~/projects/polyllm-chat/components/LegalPage';
import CookieYesEmbed from '~/projects/polyllm-chat/components/LegalPage/components/CookiePolicyPage/CookieYesEmbed';

const CookiePolicyPage: FC = () => {
  return (
    <LegalPage>
      <CookieYesEmbed />
    </LegalPage>
  );
};

export default CookiePolicyPage;
